export const setUpAlertsWeatherAlertsTranslatePaths = {
  title: 'set_up_alerts.weather_alerts.title',
  text: 'set_up_alerts.weather_alerts.text',
  minTemperature: 'set_up_alerts.weather_alerts.min_temp',
  maxTemperature: 'set_up_alerts.weather_alerts.max_temp',
  minHumidity: 'set_up_alerts.weather_alerts.min_humidity',
  maxHumidity: 'set_up_alerts.weather_alerts.max_humidity',
};
